import React from "react";
import { Content } from "../components/AllExportedComponent";

function Home() {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    React.useEffect(function () {
        async function getData(){
            try {
                const request = await fetch('https://api.github.com/users/bagussona', { 
                    method: 'GET',
                });
                const response = await request.json();
                setData(response);
                setLoading(false);
            } catch (e) { console.log(e); }
        }
        getData();
    }, []);
    return <> 
        {loading ? <div className="w-full flex justify-center items-center">fetching data ...</div> :
        <div className="flex flex-col w-full"><Content data={data} /></div>}
    </>
}

export default Home;